export type ThunkApiType = any;

// used for the document delete
// maybe we will need more keys in the future
export enum STATE_KEYS {
	CLAIM = 'claim',
	COMPLAINT = 'complaint',
	FRAUD = 'fraud',
}
